import SvgIconRetour from "@Components/CustomIcon/SvgIconRetour"
import SvgIvehteLogo from "@Components/CustomIcon/SvgIvehteLogo"
import SvgSettings from "@Components/CustomIcon/SvgSettings"
import SvgSettingsActive from "@Components/CustomIcon/SvgSettingsActive"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { baseColors, baseFontFamily } from "@Constants/baseStyles"
import { navigationAtom } from "@Recoil/navigationAtom"
import React from "react"
import { Platform, TouchableOpacity, View } from "react-native"
import { RFValue } from "react-native-responsive-fontsize"
import { useRecoilValue } from "recoil"
import headerStyles from "./headerStyles"
import { useRoute } from "@react-navigation/native"

export const CustomHeaderComponent = (props) => {
    const { back, navigation } = props
    const settingsPage = [
        "PersonalData",
        "Consent",
        "MyAccountForm",
        "UserSettings",
        "Password",
        "Profile",
        "EmailAdress",
        "FAQ",
        "BibliographySources"
    ]
    const currentNavigationPath = useRecoilValue(navigationAtom)

    const route = useRoute()

    const isHomeScreen = route?.name === "HomeScreen"
    const isAppointmentVisioContent = route?.name === "AppointmentVisioContent"

    const goBack = () => {
        if (isHomeScreen) {
            return
        }
        if (back && navigation.canGoBack()) {
            if (settingsPage.includes(currentNavigationPath) && currentNavigationPath !== "UserSettings") {
                navigation.navigate("UserSettingStack")
            } else {
                navigation.goBack()
            }
        }
    }

    const goToUserSettings = () => navigation.navigate("UserSettings")
    const goToHomePage = () => navigation.navigate("Home")

    const isAndroid = Platform.OS === "android"

    if (isAppointmentVisioContent) {
        return <View />
    }

    return (
        <View style={{ ...headerStyles.container, elevation: isAndroid ? 5 : 8 }}>
            <View style={headerStyles.goBack}>
                <TouchableOpacity onPress={() => goBack()}>{back && <SvgIconRetour />}</TouchableOpacity>
            </View>

            <TouchableOpacity onPress={goToHomePage} style={headerStyles.logo}>
                <SvgIvehteLogo />
            </TouchableOpacity>

            <TouchableOpacity style={headerStyles.params} activeOpacity={0.8} onPress={() => goToUserSettings()}>
                {settingsPage.includes(currentNavigationPath) ? (
                    <SvgSettingsActive width={25} height={25} />
                ) : (
                    <SvgSettings width={25} height={25} />
                )}
                <OpenSansText
                    textAlign="center"
                    style={{
                        marginTop: 5,
                        color: settingsPage.includes(currentNavigationPath)
                            ? baseColors.orange.primary
                            : baseColors.green.primary
                    }}
                    defaultFontFamily={baseFontFamily.OpenSansSemiBold}
                    fontSize={RFValue(12)}
                >
                    Paramètres
                </OpenSansText>
            </TouchableOpacity>
        </View>
    )
}
